import _throttle from 'lodash/throttle';
import { callInteropHandler } from '../interop/interopHelpers';

const handleUserInteraction = () => {
    callInteropHandler('userinteractionextension.UserInteractionOccurred', '');
};

const thirtySecondsInMilliseconds = 30000;

const throttledHandleUserInteraction = _throttle(handleUserInteraction, thirtySecondsInMilliseconds, {
    leading: true,
    trailing: true
});

const listenForUserInteractions = () => {
    window.addEventListener('click', throttledHandleUserInteraction, false);
    window.addEventListener('mousedown', throttledHandleUserInteraction, false);
    window.addEventListener('mousemove', throttledHandleUserInteraction, false);
    window.addEventListener('touchstart', throttledHandleUserInteraction, false);
    window.addEventListener('keydown', throttledHandleUserInteraction, false);
    window.addEventListener('scroll', throttledHandleUserInteraction, false);
    window.addEventListener('resize', throttledHandleUserInteraction, false);
}

export default listenForUserInteractions;